module.exports = __webpack_public_path__ + "static/mason-small-c2b3f74ff4d408d8a3a6941797281c3a.png";